import type { PanoramaBlock } from '$models/Block/PanoramaBlock';

export const PANORAMA_IMAGE_SOURCES = [
	{
		key: 'desktop',
		media: '(min-width: 960px)',
		imageKey: 'imageDesktop'
	},
	{
		key: 'tablet',
		media: '(min-width: 768px) and (max-width: 959px)',
		imageKey: 'imageTablet'
	},
	{
		key: 'mobile',
		media: '(max-width: 767px)',
		imageKey: 'imageMobile'
	}
] as const satisfies {
	key: 'desktop' | 'tablet' | 'mobile';
	media: string;
	imageKey: 'imageDesktop' | 'imageTablet' | 'imageMobile';
}[];

export function getPanoramaImageSources(block: PanoramaBlock) {
	return PANORAMA_IMAGE_SOURCES.map(({ key, media, imageKey }) => ({
		key,
		media,
		image: block[imageKey]
	}));
}

export function getPanoramaPreloadLinks(block: PanoramaBlock) {
	return getPanoramaImageSources(block).map(({ media, image }) => ({
		href: image.url,
		media
	}));
}
